<template>
    <div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
        <div class="add_tits" ref="titles">
            <el-form class="form-inlines " :inline="true">
                <el-form-item>
                    <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="handleAdd">添加
                    </el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="warning" icon="el-icon-refresh" size="small" @click="begin">刷新</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="height" class="tableLimit">
                <el-table-column prop="name" label="名称"> </el-table-column>
                <el-table-column prop="sort" label="排序"> </el-table-column>
                <el-table-column prop="status" label="状态">
                    <template slot-scope="scope">
                        <el-switch active-value="0" inactive-value="1" v-model="scope.row.status" active-text="开启"
                            inactive-text="关闭" @change="switchchange(scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="create_time" label="创建时间"> </el-table-column>
                <el-table-column fixed="right" label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button type="primary" size="small" @click="handleEdit(scope.row)">编辑</el-button>
                        <el-button @click="handleDelete(scope.row)" type="danger" size="small">删除</el-button>

                    </template>
                </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>
        </div>


        <!-- 设置 -->
        <el-dialog title="品牌设置" :visible.sync="dialoged" top="80px" width="60%" center class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form ref="forms" :model="forms" label-width="100px" :rules="rules" class="forms-lines">
                    <el-form-item label="名称" prop="name">
                        <el-input size="small" v-model="forms.name"></el-input>
                    </el-form-item>
                    <el-form-item label="上传图片">
                        <el-upload class="avatar-uploader" action="admin/ShopAttachments/image"  ref="upload"
                            :headers="{ token:$store.state.user.token }" :data="{ module:'brand' }"
                            :file-list="forms.fileList" :on-success="uploadSuccess" :on-remove="uploadRmove"
                            list-type="picture-card">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="内容">
                        <tinymce ref="editor" v-model="forms.content"
                            toolbar="undo redo |  formatselect | bold italic  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent  | removeformat | imageUpload" />
                    </el-form-item>
                    <el-form-item label="排序" prop="sort">
                        <el-input size="small" v-model="forms.sort"></el-input>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-radio-group v-model="forms.state">
                            <el-radio :label="0">启用</el-radio>
                            <el-radio :label="1">关闭</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submited('forms')" size="small">确 定</el-button>
                <el-button @click="dialoged = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    import tinymce from '@/components/common/tinymce.vue';
    export default {
        components: {
            tinymce
        },
        data() {
            return {
                loading: false,
                tableData: [],
                count: 0,
                currentPage: 1,
                pagesize: 15,
                height: null,

                // 
                dialoged: false,
                forms: {
                    name: '',
                    fileList: [],
                    content: '',
                    sort: '50',
                    state: 0,
                },
                mapListed: [],
                rules: {
                    name: [{
                        required: true,
                        message: '请填写名称',
                        trigger: 'blur'
                    }],
                     content: [{
                        required: true,
                        message: '请填写内容',
                        trigger: 'blur'
                    }]
                },
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getHeight()
            that.begin()
        },
        methods: {
            getHeight() {
                let that = this
                var titles = that.$refs.titles.offsetHeight
                that.height = window.innerHeight - titles - 175 + 'px'
                window.onresize = () => {
                    var titles = that.$refs.titles.offsetHeight
                    that.height = window.innerHeight - titles - 175 + 'px'
                }
            },
            // 搜索
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 15
                that.search()
            },
            search() {
                let that = this
                that.tableData = []
                that.loading = true
                axios
                    .post("/admin/ShopProductsBrand/index", {
                        page: that.currentPage,
                        page_count: that.pagesize
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.data
                        that.tableData.forEach(element => {
                            element.status = element.status.toString()
                        });
                        that.count = response.data.data.count
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            // 
            handleAdd() {
                let that = this
                that.eid = '0'
                that.dialoged = true
                this.forms.name = ''
                this.forms.fileList = []
                this.mapListed = []
                this.forms.content = ''
            },
            submited(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        var list=this.mapListed.map(item=>item.response.data.id)
                        axios
                            .post("/admin/ShopProductsBrand/editor", {
                                id: this.eid,
                                name: this.forms.name,
                                attachment_id:list,
                                photo:'',
                                content: this.forms.content,
                                sort: this.forms.sort,
                                status: this.forms.state,
                            }, {
                                token: true
                            })
                            .then(response => {
                                if (response.data.code == '200') {
                                    this.search()
                                    this.dialoged = false
                                    this.$message('操作成功');
                                } else {
                                    this.$message.error(response.data.msg);
                                }
                            })
                            .catch(error => {})
                    } else {
                        return false;
                    }
                });
            },
            async handleEdit(row) {
                this.dialoged = true
                this.eid = row.id
                this.forms.name = ''
                this.forms.fileList = []
                this.mapListed = []
                this.forms.content = ''
                await this.getinfo()
            },
            async getinfo() {
                await axios
                    .post("/admin/ShopProductsBrand/read", {
                        id: this.eid,
                    }, {
                        token: true
                    })
                    .then(response => {
                        var data = response.data.data.data
                        this.forms.name = data.name
                        var images=response.data.data.images
                        if(images){
                            images.forEach((item)=>{
                                item.url=item.path
                            })
                        }
                        images.forEach((item)=>{
                              var obj={id:'',url:'',response:{data:{}}}
                              obj.response.data=item
                                obj.id=item.id
                                 obj.url=item.url
                            this.forms.fileList.push(obj)
                            this.mapListed.push(obj)
                        })
                        this.forms.content = data.content
                         this.forms.sort = data.sort
                        
                    })
                    .catch(error => {})
            },
            handleDelete(row) {
                let that = this
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/ShopProductsBrand/del", {
                            id: row.id,
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                this.search()
                            } else {
                                that.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            // 
            uploadSuccess(response, file, fileList) {
                let that = this
                if (response.code == "201") {
                    that.$nextTick(() => {
                        let mainImg = that.$refs.upload;
                        if (mainImg) {
                            mainImg.uploadFiles.forEach((element, index) => {
                                if (file.uid == element.uid) {
                                    mainImg.uploadFiles.splice(index, 1)
                                }
                            });
                        }
                    })
                    that.$alert(response.msg)
                    return;
                }
                that.$message({
                    message: '上传成功',
                    type: 'success'
                });
                that.mapListed=fileList
            },
            uploadRmove(file, fileList) {
                this.mapListed=fileList
            },
            switchchange(row) {
                axios
                    .post("/admin/ShopProductsBrand/field", {
                        id: row.id,
                        name: "status",
                        value: row.status
                    }, {
                        token: true
                    })
                    .then(response => {})
                    .catch(error => {})
            },
        },

    };
</script>


<style scoped>
</style>